export const ONLY_WHITESPACES = 'only_whitespaces';
export const INVALID_FILE_FORMAT = 'INVALID_FILE_FORMAT';
export const FILE_NAME_TOO_LONG = 'file_name_too_long';